module.exports = __webpack_public_path__ + "static/img/course01.bb3f403.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/course01.jpg
// module id = I4ny
// module chunks = 101